import React from 'react'
import Form from 'react-bootstrap/Form'

/**
 * Component for selecting a column type from a list of options.
 * Options are selected when the table is created by the App developer.
 */
const NiTblAttrSelect = ({ value = '', onChange, disabled, list }) => {
  return (
    <Form.Control as='select' value={value} onChange={onChange} disabled={disabled} className='m-2'>
      <option value />
      {
        list.map((c, idx) => (
          <option value={c} key={idx}>{c}</option>
        ))
      }
    </Form.Control>
  )
}

export default NiTblAttrSelect
